// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-___styles-module__fallbackScreen {
  height: calc(100% - 75px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".fallbackScreen {\n  height: calc(100% - 75px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fallbackScreen": `app-pages-Project-ProductionManagement-Dashboards-___styles-module__fallbackScreen`
};
export default ___CSS_LOADER_EXPORT___;
